import toast from "react-hot-toast";

const { clientAPI } = require("../client");
export const brokerDebtDisbursementCall = {
  create: async (data) => {
    try {
      const response = await clientAPI("post", "/brokerDebtDisbursement", data);
      return response;
    } catch (error) {
      console.error("Create error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  update: async (id,data) => {
    try {
      const response = await clientAPI("put", `/brokerDebtDisbursement/${id}`, data);
      return response;
    } catch (error) {
      console.error("Update error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  delete: async (id) => {
    try {
      const response = await clientAPI("delete", `/brokerDebtDisbursement/${id}`);
      return response;
    } catch (error) {
      console.error("Delete error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  /**
   * Import thanh toán CCMG (ghi DB). Gọi sau khi importCheck đã pass.
   * @param {Array} input - [{ disbursementDate, monthYear, apartmentCode, employeeCode, employeeName, disbursedAmount }]
   * @param {string} name - Tên file gốc (dùng cho log lỗi)
   */
  import: async (input, name, mode = 2) => {
    try {
      const response = await clientAPI(
        "post",
        "/brokerDebtDisbursement/import",
        { input, name, mode }
      );
      return response;
    } catch (error) {
      console.error("import error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];
      errorMessages.forEach((message) => toast.error(`${message}`));
      throw error;
    }
  },
  /**
   * Dry-run kiểm tra file import thanh toán CCMG — không ghi DB.
   * Trả về { successCount, failedCount, path, filename }.
   */
  importCheck: async (input, name) => {
    try {
      const response = await clientAPI(
        "post",
        "/brokerDebtDisbursement/import-check",
        { input, name }
      );
      return response;
    } catch (error) {
      console.error("importCheck error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];
      errorMessages.forEach((message) => toast.error(`${message}`));
      throw error;
    }
  },
  /**
   * Lịch sử thanh toán CCMG của một nhân viên (dùng lại list endpoint, lọc theo employeeId).
   * @param {string} employeeId
   * @param {{ page?: number, limit?: number }} options
   */
  getHistory: async (employeeId, { page = 1, limit = 20 } = {}) => {
    try {
      const queryParams = new URLSearchParams({ employeeId, page, limit }).toString();
      const response = await clientAPI(
        "get",
        `/brokerDebtDisbursement?${queryParams}`
      );
      return response;
    } catch (error) {
      console.error("getHistory error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (e) => e.message
      ) || [
        error?.response?.data?.message || error?.message || "An unexpected error occurred.",
      ];
      errorMessages.forEach((message) => toast.error(`${message}`));
      throw error;
    }
  },
};